import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook for navigation
import Slider from "react-slick";
import Slide1Img from "../../../assets/images/slide1.png";
import Slide2Img from "../../../assets/images/slide2.png";
import Slide3Img from "../../../assets/images/slide3.png";
import LocationSvg from "../../../assets/images/location.svg";
import CalenderSvg from "../../../assets/images/calendar.svg";
import "./HeroBannerStyle.css";
import { DatePicker } from "antd";
import moment from "moment";
import { useStaticPageContent } from "../../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../../data/staticContentDefaults";
import { getStaticContentImage } from "../../../utils/staticContentImages";
import CmsRichText, { cmsPlainText } from "../../common/CmsRichText";
import { mergeHeroHeadingHtml } from "../../../utils/cmsHeadingUtils";

const HeroBannerSec = () => {
  const pageContent = useStaticPageContent("home");
  const heroContent =
    pageContent?.hero || staticContentDefaults.home.hero;
  const searchForm =
    heroContent?.searchForm || staticContentDefaults.home.hero.searchForm;
  const headingParts =
    heroContent?.headingParts || staticContentDefaults.home.hero.headingParts;
  const carouselSlides = heroContent?.carouselSlides?.length
    ? heroContent.carouselSlides
    : staticContentDefaults.home.hero.carouselSlides;
  const defaultSlideImages = [Slide1Img, Slide2Img, Slide3Img];
  const [selectedCategories, setSelectedCategories] = useState({
    all: false,
    fullyFurnished: false,
    customise: false,
  });
  const [location, setLocation] = useState(""); // Track location input
  const [latLong, setLatLong] = useState({
    lat: "",
    lng: ""
  })
  const [selectedOption, setSelectedOption] = useState("");
  const [date, setDate] = useState(""); // Track date input
  const [showErrors, setShowErrors] = useState(false);
  const navigate = useNavigate(); // Hook to navigate to different pages
  const addressRef = useRef(null);
  const settings = {
    dots: true,
    slidesToShow: 1,
    infinite: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    if (id === "all") {
      setSelectedCategories({
        all: checked,
        fullyFurnished: checked,
        customise: checked,
      });
    } else {
      setSelectedCategories((prevState) => {
        const updatedState = { ...prevState, [id]: checked };
        // const allChecked = Object.values(updatedState).every((val) => val);
        const bothSelected =
          updatedState.fullyFurnished && updatedState.customise;

        return {
          ...updatedState,
          all: bothSelected,
        };
      });
    }
  };

  const handleSearchClick = () => {
    setShowErrors(true);
    if (!location?.trim()) {
      return;
    }
    // Create a new URLSearchParams instance to hold query parameters
    const queryParams = new URLSearchParams();

    // Append only non-empty or non-null fields to the query parameters
    if (location) {
      queryParams.append("searchKey", location);
    }
    if (selectedOption) {
      queryParams.append("house_type", selectedOption);
    }
    if (date) {
      queryParams.append("date", date);
    }
    if (latLong.lat && latLong.lng) {
      queryParams.append("lat", latLong.lat);
      queryParams.append("lng", latLong.lng);
    }

    // Append selected categories if they are true
    Object.keys(selectedCategories).forEach((category) => {
      if (!selectedCategories.all && selectedCategories[category]) {
        if (category === "fullyFurnished" || category === "customise") {
          let categs =
            category === "fullyFurnished" ? "fully furnished" : "customize";
          queryParams.append("house_facility", categs);
        }
      }
    });
    if (queryParams)
      // Redirect user to the search results page with the constructed query parameters
      navigate(`/properties?${queryParams.toString()}`);
  };
  const handleDateChange = (value) => {
    setDate(value ? value.format("YYYY-MM-DD") : null); // Format the date to 'yyyy-mm-dd'
  };
  const handleDropboxChange = (event) => {
    setSelectedOption(event.target.value);
    console.log(event.target.value); // You can replace this with your desired logic
  };
  useEffect(() => {
    if (!window.google || !addressRef.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      addressRef.current,
      {
        componentRestrictions: { country: "us" },
        fields: ["formatted_address", "geometry"],
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.geometry) return; // invalid selection

      const newAddress = place.formatted_address;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      // Update your state with full address + coordinates
      setLatLong({ lat, lng });
      setLocation(newAddress);
    });
  }, []);
  return (
    <Fragment>
      <div className="banner-section">
        <div className="search-form">
          <div className="input-sec input-sec1">
            <label htmlFor="location" className="form-label">
              <CmsRichText as="span" value={searchForm.locationLabel} />
              <span className="star_symb">*</span>
            </label>
            <div className="search_image_icon">
              <img src={LocationSvg} />
              <input
                type="text"
                className="form-control"
                id="location"
                placeholder={cmsPlainText(searchForm.locationPlaceholder)}
                value={location}
                onChange={(e) => setLocation(e.target.value)} // Update location state
                ref={addressRef}
              />
              {showErrors && !location && (
                <div className="loc-error">
                  <CmsRichText as="span" value={searchForm.locationError} />
                </div>
              )}
            </div>
          </div>
          {/* <div className="input-sec input-sec1">
            <label htmlFor="date" className="form-label">
              Start Date<span className="star_symb">*</span>
            </label>
            <div className="search_image_icon calander-input">
              {/* <img src={CalenderSvg} /> */}
          {/* <input
                type="date"
                className="form-control"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)} // Update date state
                min={
                  new Date(new Date().setDate(new Date().getDate() + 1))
                    .toISOString()
                    .split("T")[0]
                }
              />  // 
              <DatePicker
                id="date"
                className="dpc"
                // value={date ? moment(date, "YYYY-MM-DD") : null} // Format the value for DatePicker
                onChange={handleDateChange} // Handle date change
                disabledDate={(current) =>
                  current.isBefore(moment().add(2, "days"), "day")
                } // Disable past dates and today
                format="YYYY-MM-DD" // Set the date format
                inputReadOnly
              />
            </div>
          </div> */}
          <div className="input-sec input-sec1">
            <label htmlFor="propertyType" className="form-label">
              <CmsRichText as="span" value={searchForm.propertyTypeLabel} />{" "}
            </label>
            <div className="search_dropdown-icon-select search_image_icon">
              <select
                id="propertyType"
                className="form-control dpc"
                onChange={handleDropboxChange}
              >
                {searchForm.propertyTypeOptions.map((option) => (
                  <option key={option.value || "all"} value={option.value}>
                    {cmsPlainText(option.label)}
                  </option>
                ))}
              </select>
              <span className="dropdown-icon-select">&#9662;</span>
            </div>
          </div>
          <div className="input-sec input-sec2">
            <label htmlFor="category" className="form-label">
              <CmsRichText as="span" value={searchForm.categoryLabel} />
              <span className="star_symb">*</span>
            </label>
            <div className="choose-sec">
              {/* "All" checkbox */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="all"
                  checked={selectedCategories.all}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="all">
                  <CmsRichText
                    as="span"
                    value={
                      searchForm.categoryOptions.find((item) => item.id === "all")
                        ?.label || "All"
                    }
                  />
                </label>
              </div>

              {/* "Fully Furnished" checkbox */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="fullyFurnished"
                  checked={selectedCategories.fullyFurnished}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="fullyFurnished">
                  <CmsRichText
                    as="span"
                    value={
                      searchForm.categoryOptions.find(
                        (item) => item.id === "fullyFurnished"
                      )?.label || "Fully Furnished"
                    }
                  />
                </label>
              </div>

              {/* "customise" checkbox */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="customise"
                  checked={selectedCategories.customise}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="customise">
                  <CmsRichText
                    as="span"
                    value={
                      searchForm.categoryOptions.find(
                        (item) => item.id === "customise"
                      )?.label || "Unfurnished"
                    }
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="input-sec button-sec">
            <button className="handleSearchClick" onClick={handleSearchClick}>
              <CmsRichText as="span" value={searchForm.searchButton} />
            </button>{" "}
            {/* Change anchor to button */}
          </div>
        </div>
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <Slider {...settings}>
            {carouselSlides.map((slide, index) => (
              <div className="carousel-item active" key={`${slide.image}-${index}`}>
                <img
                  src={getStaticContentImage(
                    slide.image,
                    defaultSlideImages[index] || Slide1Img
                  )}
                  alt="..."
                />
              </div>
            ))}
          </Slider>
        </div>
        <div className="search-home my-container">
          <div className="search-header">
            <h1>
              <CmsRichText as="span" value={mergeHeroHeadingHtml(headingParts)} />
            </h1>
            <p>
              <CmsRichText as="span" value={heroContent.subtext} />
            </p>
            <span className="search-title--content">
              &ldquo;<CmsRichText as="span" value={heroContent.quote} />&rdquo;
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HeroBannerSec;
